import { EstateDirectHoldings } from '@/modules/estate/EstateDirectHoldings/EstateDirectHoldings';

export function ClientEstateDirectHoldingsPage() {
  return <EstateDirectHoldings />;
}
